import React from 'react';
import $ from "jquery";
import { Button, Dropdown, Input } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Loading from '../../loading';
import Server from '../../../functions/server';

export default class ServiceType extends React.Component {

    state = {
        values: {}, machineOption: []
    }

    componentDidMount() {
        this.getMachine();
    }

    getMachine = () => {
        let context = this;
        this.setState({ load: true, message: 'Getting Machine!!!' })
        $.ajax({
            type: 'POST',
            url: Server()+'machineinfo/get.php',
            success: function(data) {
                context.setState({ load: false })
                try {
                    data = JSON.parse(data);
                    var machineOption = [];
                    data.map((y) => {
                        let text = y.id+'->'+y.name;
                        machineOption.push({key: text, text: text, value: y.name});
                    });
                    context.setState({ data, machineOption })
                } catch (e) {

                }
            },
            error: function(e) {
                alert('Try again!!')
                context.setState({ load: false });
            }
        });
    }



  AddEditmaster = () => {
    let context = this;
    let  { values } = this.state;
    let  { item } = this.props;
    let url = Server()+'machine/ServiceType/AddMaster.php';
    if (item) {
        url = Server()+'machine/ServiceType/EditMaster.php'
    }
    context.setState({ load: true, message: 'Adding Service Master!!!' })
    $.ajax({
      type: 'POST', data: values,
      url: url,
      success: function(data) {
          if (data == 1) {
              context.setState({ values: {}, AddMasterDialog: false, load: false })
              context.props.refresh();
          }
          else {
              context.setState({ load: false })
              alert('Error')
          }
      },
      error: function(e) {
            context.setState({ load: false })
          alert('Try again!!')
      }
  });
  }

  textHandle = (key) => event => { 
    this.setState({
        values: {
        ...this.state.values,
        [key]: event.target.value
        },
    });
  }

  selectStatus = (f, { value }) => {
    this.setState({
        values: {
            ...this.state.values,
            "status": value
        }
    })
}

selectMachine = (f, { value }) => {
    this.setState({
        values: {
            ...this.state.values,
            "machine": value
        }
    })
}

  render() {
      let { item } = this.props;
      let statusOption = [
          { key: 'Active', text: 'Active', value: 1},
          { key: 'InActive', text: 'InActive', value: 0}
      ]
      let {  values, machineOption, load, message } = this.state;
    return (
      <div>
          <Loading load={load} message={message} />
          { item ? 
            <u onClick={ () => { this.setState({ values: item, AddMasterDialog: true }) }}>Edit</u>:
            <Button onClick={ () => { this.setState({ values: {}, AddMasterDialog: true }) }}>Add Master</Button>
          }

            <Dialog fullWidth={true} maxWidth={'xs'} open={this.state.AddMasterDialog}
                onClose={ () => { this.setState({ AddMasterDialog: false }) }}
                aria-labelledby="max-width-dialog-title" >
                <DialogTitle id="max-width-dialog-title">{'Add Master'}</DialogTitle>
                <DialogContent>
                    <b>Select Machine</b><br/>
                    <Dropdown placeholder='Machine' style={{width: '100%'}} onChange={this.selectMachine} 
                        search selection 
                        options={machineOption} value={values.machine} /><br/><br/>
                    <b>Service Name</b>
                    <Input style={{width: '100%'}} placeholder='Service Name' 
                        value={values.name} onChange={this.textHandle('name')} />
                    <br/><br/><b>Status</b><br/>
                    <Dropdown placeholder='Status' style={{width: '100%'}} onChange={this.selectStatus} search selection 
                        options={statusOption} value={values.status} />
                    <br/><br/><br/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={ () => { this.setState({ values: {}, AddMasterDialog: false }) }}>Close</Button>
                    <Button onClick={this.AddEditmaster}>Add Master</Button>
                </DialogActions>
            </Dialog>

      </div>
    );
  }

}